import React, { isValidElement } from 'react';
import { useOrchestrator } from '../core/context';
function hasReactType(component) {
  return typeof component === 'object' && component !== null && !Array.isArray(component) && '$$typeof' in component;
}
function isComponentMap(component) {
  return typeof component === 'object' && component !== null && !Array.isArray(component) && !component.$$typeof;
}
function renderComponent(component) {
  if (component == null) {
    return null;
  }
  if (/*#__PURE__*/isValidElement(component)) {
    return component;
  }
  if (typeof component === 'function' || hasReactType(component)) {
    const Component = component;
    return /*#__PURE__*/React.createElement(Component);
  }
  return component;
}
export function StepRenderer(_temp) {
  let {
    componentKey
  } = _temp === void 0 ? {} : _temp;
  const {
    currentStep,
    isLoading,
    loadingComponent
  } = useOrchestrator();
  if (isLoading && loadingComponent) {
    return /*#__PURE__*/React.createElement(loadingComponent);
  }
  if (!currentStep) {
    return null;
  }
  const {
    component
  } = currentStep;
  if (isComponentMap(component)) {
    if (!componentKey) {
      console.warn('StepRenderer: componentKey is required when using multi-component mode');
      return null;
    }
    const componentMap = component;
    const Component = componentMap[componentKey];
    if (!Component) {
      console.warn(`StepRenderer: component "${componentKey}" not found in step`);
      return null;
    }
    return renderComponent(Component);
  }
  if (componentKey) {
    console.warn('StepRenderer: componentKey provided but step has single component');
  }
  return renderComponent(component);
}
//# sourceMappingURL=StepRenderer.js.map